module.exports = __webpack_public_path__ + "453ab2acfe227236894faaf92d0a7a9f.svg";